const PREFIX = 'MEMBER_PROFILE_USAGE_LOG_';

export const SET_LOADING = `${PREFIX}SET_LOADING`;
export const UNSET_LOADING = `${PREFIX}UNSET_LOADING`;
export const SET_FACILITY_USAGES_GROUP = `${PREFIX}SET_FACILITY_USAGES_GROUP`;
export const GET_USAGE_LOG_SUCCESS = `${PREFIX}GET_USAGE_LOG_SUCCESS`;
export const SET_SELECTED_USAGE_PERIOD = `${PREFIX}SET_SELECTED_USAGE_PERIOD`;
export const SET_FACILITY_USAGES_GROUP_LOADING = `${PREFIX}SET_FACILITY_USAGES_GROUP_LOADING`;
export const UNSET_FACILITY_USAGES_GROUP_LOADING = `${PREFIX}UNSET_FACILITY_USAGES_GROUP_LOADING`;